// Defines the helper Dawn and many themes expect.
window.fetchConfig = function(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Accept': `application/${type}`,
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin'
  };
};
